import React from 'react'

const SuggestAFeature = (props) => (
  <svg width={props.width ? props.width : "24"}
       height={props.height ? props.height : "24"}
       fill={props.color ? props.color : "#97A3C7"}
       viewBox="0 0 24 24"
       xmlns="http://www.w3.org/2000/svg"
  >
    <path fillRule="evenodd" clipRule="evenodd"
          d="M10 18V21C10 21.5523 10.4477 22 11 22H13C13.5523 22 14 21.5523 14 21V18H16V21C16 22.6569 14.6569 24 13 24H11C9.34315 24 8 22.6569 8 21V18H10Z"
    />
    <path fillRule="evenodd" clipRule="evenodd"
          d="M15 13.2853L15.7491 12.6849C17.1248 11.582 18 9.89389 18 8C18 4.68629 15.3137 2 12 2C8.68629 2 6 4.68629 6 8C6 9.89389 6.87516 11.582 8.25094 12.6849L9 13.2853V16C9 16.5523 9.44772 17 10 17H14C14.5523 17 15 16.5523 15 16V13.2853ZM17 14.2454V16C17 17.6569 15.6569 19 14 19H10C8.34315 19 7 17.6569 7 16V14.2454C5.17107 12.7793 4 10.5264 4 8C4 3.58172 7.58172 0 12 0C16.4183 0 20 3.58172 20 8C20 10.5264 18.8289 12.7793 17 14.2454Z"
    />
    <path
      d="M10.7071 8.29289C10.3166 7.90237 9.68342 7.90237 9.29289 8.29289C8.90237 8.68342 8.90237 9.31658 9.29289 9.70711L11 11.4142V17H13V11.4142L14.7071 9.70711C15.0976 9.31658 15.0976 8.68342 14.7071 8.29289C14.3166 7.90237 13.6834 7.90237 13.2929 8.29289L12 9.58579L10.7071 8.29289Z"
    />
  </svg>
)

export default SuggestAFeature
